"use client"
import clx from 'classnames';
import React, { useEffect, useState } from 'react';
import { FiArrowLeft } from 'react-icons/fi';

const PickAvatar = () => {

    useEffect(()=>{document.body.style.background='#111827'})
    const [avatar, setAvatar] = useState(1)
    const [tab, setTab] = useState(1)

    return (
        <React.Fragment>
            <div className="absolute left-20 top-10 w-52 h-52 bg-[#9715D9] blur-[80px]"></div>
            <div className="absolute left-72 top-72 w-52 h-52 bg-[#DA145F] blur-[80px]"></div>
            <div className="absolute left-20 top-96 w-52 h-52 bg-[#F71135] blur-[80px]"></div>
            <div className="absolute right-20 top-10 w-52 h-52 bg-[#3C45FA] blur-[80px]"></div>
            <div className="absolute right-52 top-72 w-52 h-52 bg-[#7E1FF9] blur-[80px]"></div>
        
            <div className="relative z-50 w-full h-screen flex flex-col items-center justify-center text-white" >

                <div className={clx({'hidden':tab!=1},`flex flex-start flex-col`)} >
                    <h1 className="text-4xl font-white font-bold">Pick an avatar</h1>
                    <div className="flex gap-5 my-5" x-data="{avatar:1}">
                        <img src="/images/avatars/Vector-10.png" onClick={()=>setAvatar(1)} className={clx(avatar==1&&'bg-white',`h-30 w-30 rounded-full cursor-pointer border-4 border-transparent`)} />
                        <img src="/images/avatars/Vector-11.png" onClick={()=>setAvatar(2)} className={clx(avatar==2&&'bg-white',`h-30 w-30 rounded-full cursor-pointer border-4 border-transparent`)} />
                        <img src="/images/avatars/Vector-12.png" onClick={()=>setAvatar(3)} className={clx(avatar==3&&'bg-white',`h-30 w-30 rounded-full cursor-pointer border-4 border-transparent`)} />
                        <img src="/images/avatars/Vector-13.png" onClick={()=>setAvatar(4)} className={clx(avatar==4&&'bg-white',`h-30 w-30 rounded-full cursor-pointer border-4 border-transparent`)} />
                        <img src="/images/avatars/Vector-14.png" onClick={()=>setAvatar(5)} className={clx(avatar==5&&'bg-white',`h-30 w-30 rounded-full cursor-pointer border-4 border-transparent`)} />
                        <img src="/images/avatars/Vector-15.png" onClick={()=>setAvatar(6)} className={clx(avatar==6&&'bg-white',`h-30 w-30 rounded-full cursor-pointer border-4 border-transparent`)} />
                    </div>
                        <div 
                        onClick={()=>setTab(2)}
                        className="shadows cursor-pointer text-white rounded-md p-3 px-6 w-max flex items-center justify-center gap-4"> <p>Set as Profile Picture</p> <i data-feather="arrow-right" className="h-5"></i> </div>
                </div>


                <div className={clx({'hidden':tab!=2},"flex flex-start flex-col w-[400px]")} >
                    <div className="flex items-center w-full justify-between">
                        <div  onClick={()=>setTab(1)} className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center">
                            <FiArrowLeft className="w-8 cursor-pointer" />
                        </div>
                        <h1 className="text-4xl font-white font-bold">Enter an username</h1>
                    </div>
                    <input type="text" placeholder="Username" className="my-6 text-gray-700 outline-blue-500 rounded-md p-3 bg-transparent border border-2 border-zinc-800/50 text-white" />
                    <div className="shadows cursor-pointer text-white rounded-md p-3 px-6 w-max">Set username</div>
                </div>

            </div>

        
            
        </React.Fragment>
    )
}

export default PickAvatar